import * as core from '../../../../../../../core'

import { query } from './support-needs-by-department.query'

export const RESOURCE = {
  payload: {
    alias: 'support.needs.by.department',
    description: 'Chart view of support needs by department',
    name: 'Support Needs by Department',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
